export const ROOT = '/';

export const ROUTES = {
  dashboard: `${ROOT}dashboard`,
  login: `${ROOT}login`,
  system: `${ROOT}system`,
  user: `${ROOT}users/:userId`,
  users: `${ROOT}users`,
  affiliates: `${ROOT}affiliates`,
  affiliatesProfileTransfer: `${ROOT}affiliates/profile-transfer`,
  affiliatesOnlineOfflineAccess: `${ROOT}affiliates/online-offline-access`,
  administrators: `${ROOT}administrators`,
  createAdministrator: `${ROOT}administrators/create`,
  administrator: `${ROOT}administrators/:administratorId`,
  payments: `${ROOT}payments`,
  withdrawals: `${ROOT}withdrawals`,
  photos: `${ROOT}photos`,
  reports: `${ROOT}reports`,
  cardVerification: `${ROOT}reports?tab=card-verification`,
  coPilotOptions: `${ROOT}reports?tab=co-pilot-options`,
  coPilotStatistics: `${ROOT}reports?tab=co-pilot-statistics`,
};

export const ROUTES_TITLES = {
  [ROUTES.dashboard]: 'Dashboard',
  [ROUTES.login]: 'Dating Admin - Login',
  [ROUTES.system]: 'System',
  [ROUTES.user]: 'User',
  [ROUTES.users]: 'Users',
  [ROUTES.affiliates]: 'Affiliates',
  [ROUTES.affiliatesProfileTransfer]: 'Profile Transfer',
  [ROUTES.affiliatesOnlineOfflineAccess]: 'Online/Offline Access',
  [ROUTES.administrators]: 'Администраторы',
  [ROUTES.createAdministrator]: 'Создание администратора',
  [ROUTES.administrator]: 'Редактирование администратора',
  [ROUTES.payments]: 'Payments',
  [ROUTES.withdrawals]: 'Withdrawals',
  [ROUTES.reports]: 'Perfect Match',
  [ROUTES.photos]: 'Photos',
  default: 'Dating Admin',
};
